const DeleteIcon = () => {
    return (
        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="30" height="30" rx="4" fill="white" fill-opacity="0.06"/>
            <path
                d="M8.5 10.2H10.0556M10.0556 10.2H22.5M10.0556 10.2V21.4C10.0556 21.8243 10.2194 22.2313 10.5112 22.5314C10.8029 22.8314 11.1986 23 11.6111 23H19.3889C19.8014 23 20.1971 22.8314 20.4888 22.5314C20.7806 22.2313 20.9444 21.8243 20.9444 21.4V10.2H10.0556ZM12.3889 10.2V8.6C12.3889 8.17565 12.5528 7.76869 12.8445 7.46863C13.1362 7.16857 13.5319 7 13.9444 7H17.0556C17.4681 7 17.8638 7.16857 18.1555 7.46863C18.4472 7.76869 18.6111 8.17565 18.6111 8.6V10.2M13.9444 14.2V19M17.0556 14.2V19"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}
export default DeleteIcon;